export default __webpack_public_path__ + "static/media/aug_banner_highlight.9dafb2d1.png";